import { useMutation } from "@tanstack/react-query";

import { getAuth, isProfileAuth } from "~/providers/store/auth";
import { useAppContext } from "~/providers/app";
import { DisplayError, DisplayErrorCodeEnum } from "~/utils/display-error";

import {
  createCashDrawerOpenPosLog,
  type CashDrawerTrigger
} from "../requests";

export function useCreateCashDrawerOpenPosLog() {
  const {
    hardware: { printer }
  } = useAppContext();

  return useMutation({
    mutationFn: (trigger: CashDrawerTrigger) => {
      const auth = getAuth();
      if (!isProfileAuth(auth)) {
        throw new DisplayError(DisplayErrorCodeEnum.PROFILE_NOT_SELECTED);
      }

      return createCashDrawerOpenPosLog({
        printerId: printer?.identifier ?? "unknown",
        profileId: auth.profileId,
        userId: auth.userId,
        tillId: auth.tillId,
        trigger
      });
    }
  });
}
